/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * breaksReports
 * @export
 * @interface BreaksRequest
 */
export interface BreaksRequest {
    /**
     * 営業所ID
     * @type {number}
     * @memberof BreaksRequest
     */
    officeId?: number;
    /**
     * multiple営業所で検索のためのリスト
     * @type {Array<number>}
     * @memberof BreaksRequest
     */
    officeIds?: Array<number>;
    /**
     * 乗務員ID
     * @type {number}
     * @memberof BreaksRequest
     */
    driverId?: number;
    /**
     * 年月日
     * @type {number}
     * @memberof BreaksRequest
     */
    shiftDate?: number;
}

export function BreaksRequestFromJSON(json: any): BreaksRequest {
    return BreaksRequestFromJSONTyped(json, false);
}

export function BreaksRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BreaksRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'officeId': !exists(json, 'office_id') ? undefined : json['office_id'],
        'officeIds': !exists(json, 'office_ids') ? undefined : json['office_ids'],
        'driverId': !exists(json, 'driver_id') ? undefined : json['driver_id'],
        'shiftDate': !exists(json, 'shift_date') ? undefined : json['shift_date'],
    };
}

export function BreaksRequestToJSON(value?: BreaksRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'office_id': value.officeId,
        'office_ids': value.officeIds,
        'driver_id': value.driverId,
        'shift_date': value.shiftDate,
    };
}


